import React from "react";
import "./Products.scss";
import Sidebar from "../Sidebar/Sidebar";
import { Link } from "react-router-dom";
import axios from "axios";
import * as backendModule from "../../modules/backendModule";
import Spinner from "../Spinner";

const Products = () => {

    const [data, setData] = React.useState(null);
    const [spinner, setSpinner] = React.useState(false);
    const [paginationSpinner, setPaginationSpinner] = React.useState(false);
    const [deleteSpinner, setDeleteSpinner] = React.useState(false);
    const [paginationMessage, setPaginationMessage] = React.useState(null);
    const [error, setError] = React.useState(null);

    const getAllProducts = (offset, limit) => {
        setPaginationMessage(null);
        setSpinner(true);
        axios({
            method: "POST",
            url: `${backendModule.backendURL}/products/getAllProducts`,
            data: {
                filters: [],
                offset: offset,
                limit: limit
            },
            ...backendModule.axiosConfig,
        }).then(res => {
            if (res.data.status === "ok") {
                setData(res.data?.data);
            } else {
                setError('Došlo je do serverske greške');
            }
        }).catch(() => {
            setError('Došlo je do serverske greške');
        }).finally(() => {
            setSpinner(false);
        });
    }

    const getProductsPagination = (offset, limit) => {
        axios({
            method: "POST",
            url: `${backendModule.backendURL}/products/getAllProducts`,
            data: {
                filters: [],
                offset: offset,
                limit: limit
            },
            ...backendModule.axiosConfig,
        }).then(res => {
            if (res.data.status === "ok") {
                if (res.data.data.length === 0) {
                    setPaginationMessage('Nema više podataka');
                }
                else {
                    setData(prev => [...prev, ...res.data.data]);
                }
            } else {
                setPaginationMessage('Došlo je do serverske greške');
            }
        }).catch(() => {
            setPaginationMessage('Došlo je do serverske greške');
        }).finally(() => {
            setPaginationSpinner(false);
        });
    }

    const deleteProduct = (id) => {
        setDeleteSpinner(true);
        axios({
            method: "POST",
            url: `${backendModule.backendURL}/products/removeProduct`,
            data: {
                ID: id
            },
            ...backendModule.axiosConfig,
        }).then(res => {
            if (res.data.status === "ok") {
                getAllProducts(0, 12);
            } else {
                setError('Došlo je do serverske greške');
            }
        }).catch(() => {
            setError('Došlo je do serverske greške');
        }).finally(() => {
            setDeleteSpinner(false);
        });
    }

    React.useEffect(() => {
        getAllProducts(0, 12);
    }, []);

    return (
        <div className="products">
            <Sidebar />
            <div className="products__container">
                <div className="products__container__header">
                    <Link to="/admin/products/addNew">
                        <div className="products__container__header__button">
                            <p>Dodaj novi proizvod</p>
                        </div>
                    </Link>
                </div>
                <div className='products__container__prodGrid'>
                    <div className='products__container__prodGrid__content'>
                        {
                            !spinner && !error ? data?.map(product => {
                                return <div className='products__container__prodGrid__content__singleProduct'>
                                    <div className='products__container__prodGrid__content__singleProduct__top'>
                                        <img src={`${backendModule.backendURL}/${product.ImagePath}`} alt='' />
                                        <div className='products__container__prodGrid__content__singleProduct__top__right'>
                                            <h1>{product.Name}</h1>
                                            <span className='products__container__prodGrid__content__singleProduct__top__right__span'>
                                                <p className='products__container__prodGrid__content__singleProduct__top__right__span__privacy'>{product.Brand}</p>
                                                <p className='products__container__prodGrid__content__singleProduct__top__right__span__category'>{product.Category}</p>
                                            </span>
                                        </div>
                                    </div>
                                    <div className='products__container__prodGrid__content__singleProduct__middle'>
                                        <div className='products__container__prodGrid__content__singleProduct__middle__field'>
                                            <label>ID</label>
                                            <p>{product.ID}</p>
                                        </div>
                                        <div className='products__container__prodGrid__content__singleProduct__middle__field'>
                                            <label>Model</label>
                                            <div className='products__container__prodGrid__content__singleProduct__middle__field__country'>
                                                <p>{product.Model}</p>
                                            </div>
                                        </div>
                                        <div className='products__container__prodGrid__content__singleProduct__middle__field'>
                                            <label>Cijena</label>
                                            <p>{product.Price} KM</p>
                                        </div>
                                    </div>
                                    <div className='products__container__prodGrid__content__singleProduct__bottom'>
                                        <div onClick={() => deleteProduct(product.ID)} className='products__container__prodGrid__content__singleProduct__bottom__btn'>
                                            {!deleteSpinner ? <p>OBRIŠI</p> : <Spinner color="whitesmoke" style={{ width: "24px", height: "24px", marginLeft: "auto", marginRight: "auto", display: "block" }} />}
                                        </div>
                                        <Link to={`/admin/products/editProduct?id=${product.ID}`}>
                                            <div className='products__container__prodGrid__content__singleProduct__bottom__btn'>
                                                <p>UREDI</p>
                                            </div>
                                        </Link>
                                        <div className='products__container__prodGrid__content__singleProduct__bottom__model'>
                                            <p>{product.Available ? 'DOSTUPNO' : 'NEDOSTUPNO'}</p>
                                        </div>
                                    </div>
                                </div>
                            }) : null
                        }
                        {spinner && <Spinner style={{ width: '64px', height: '50px', marginLeft: '20px', marginRight: 'auto', display: 'block' }} color='#1A1A1A' />}
                        {error && <p style={{ color: 'red', marginLeft: '20px', fontSize: '16px' }}>{error}</p>}
                    </div>
                </div>
                {data?.length > 11 && <div className='products__container__prodGrid__pagination'>
                    {!paginationSpinner && !paginationMessage ? <div onClick={() => { setPaginationSpinner(true); getProductsPagination(data?.length, 12) }} className='products__container__prodGrid__pagination__button'>
                        <p>Učitaj još</p>
                    </div> : null}
                    {paginationSpinner && <Spinner style={{ width: '64px', height: '50px', marginLeft: 'auto', marginRight: 'auto', display: 'block' }} color='#1A1A1A' />}
                    {paginationMessage && <p style={{ color: 'maroon', fontSize: '15px' }}>{paginationMessage}</p>}
                </div>}
            </div>
        </div>
    );
};

export default Products;
